import { useTranslation } from 'react-i18next';

import { Body1, Heading2, Stack } from '@myphx-engineering/phx-design-system';

import { getFragment } from '../../../graphql';
import type { OfferFragment } from '../../../types';
import { getShippingMethodFromOffer } from '../../../util/offers/get-shipping-method';
import { hasPHX502 } from '../../../util/offers/sort';
import { LocationInfo } from '../../common/LocationInfo';
import { ConditionalComponent } from '../../utility/ConditionalComponent';

export const PharmacyProviderDetails = ({
    offer,
}: {
    offer: OfferFragment;
}) => {
    const { t } = useTranslation();

    const location = getFragment(offer.pharmacyProvider);
    const pharmacyDoesNotCarryMedication = hasPHX502(offer);
    const shippingMethod = pharmacyDoesNotCarryMedication
        ? null
        : getShippingMethodFromOffer(offer);

    let description;
    switch (location.__typename) {
        case 'MailOrderProvider':
            if (location.url) {
                description = t('previewDetails.description.mailOrderWebsite');
            } else if (location.phoneNumber) {
                description = t('previewDetails.description.mailOrderPhone');
            }
            break;
        default:
            description = t('previewDetails.description.pickUp');
            break;
    }

    const controlledSubstanceCode = getFragment(
        offer.medication
    ).controlledSubstanceCode;

    //temp
    const isInstantRouting = false;

    const displayRegulatoryInfo =
        !isInstantRouting && !!controlledSubstanceCode;

    return (
        <Stack gap="sm">
            <Heading2>{t('previewDetails.heading')}</Heading2>
            {offer.prescriberOrder &&
            !controlledSubstanceCode &&
            !pharmacyDoesNotCarryMedication ? (
                <Body1>{description}</Body1>
            ) : null}
            <ConditionalComponent condition={!!location}>
                <LocationInfo
                    location={location}
                    shippingMethod={shippingMethod}
                />
            </ConditionalComponent>
            <ConditionalComponent condition={displayRegulatoryInfo}>
                <Body1>{t('previewDetails.controlledSubstances')}</Body1>
            </ConditionalComponent>
        </Stack>
    );
};
